import { render, staticRenderFns } from "./HelpdeskTickets.vue?vue&type=template&id=4dc64f2a&scoped=true"
import script from "./HelpdeskTickets.vue?vue&type=script&lang=js"
export * from "./HelpdeskTickets.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTickets.vue?vue&type=style&index=0&id=4dc64f2a&prod&scoped=true&lang=css"
import style1 from "./HelpdeskTickets.vue?vue&type=style&index=1&id=4dc64f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc64f2a",
  null
  
)

export default component.exports